if (!customElements.get('tpt-video-modal')) {
	customElements.define(
		'tpt-video-modal',
		class TptVideoModal extends HTMLElement {
			constructor() {
				super();

				const toggleModalVideos = this.querySelectorAll('.tpt-toggle-video-modal');

				toggleModalVideos.forEach((btn) => {
					btn.addEventListener('click', this.toggleModalVideo.bind(this));
					btn.addEventListener('keypress', this.keyPress);
				});
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleModalVideo();
				}
			}

			toggleModalVideo() {
				this.classList.toggle('active');
			}
		}
	);
}
